module.exports = __webpack_public_path__ + "ea3016f30b8730f70e36c6679d889613.png";